import { IAppState } from 'shared/common/state';

export const selectAutoScrollSettings = (state: IAppState) => state.featureToggle.autoScrollSettings;
